import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FloatingMenuService {
    private activeMenuSource = new BehaviorSubject<string | null>(null);
    activeMenu$ = this.activeMenuSource.asObservable();

    setActiveMenu(menuId: string | null) {
        this.activeMenuSource.next(menuId);
    }

    closeAll() {
        this.activeMenuSource.next(null);
    }
}
